import "./pricing.css";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import DeleteIcon from "@mui/icons-material/Delete";
import React, { useState, useEffect } from "react";
import ScrollableComponent from "../ScrollableComponent";
import { fetchWithAuth } from "../../utils/fetchWithAuth";

export default function Pricing({
  data = [],
  setSelectedTab,
  setPricingResultData,
}) {
  const [tableData, setTableData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [editRow, setEditRow] = useState(null);
  const [errors, setErrors] = useState({});
  const storedUnitNumber = localStorage.getItem("unitNumber");
  const [loading, setLoading] = useState(false);
  localStorage.setItem("model", JSON.stringify(tableData[0]?.model || "X"));

  useEffect(() => {
    const quantity = 1;
    const storedModel = localStorage.getItem("model");
    if (data && data.length !== 0) {
      let updateData = data.map((obj, index) => ({ 
        ...obj, 
        quantity,
        id: obj.id || `${Date.now()}-${index}` 
      }));
      if (data[0] && !data[0].model) {
        updateData = updateData.map((obj) => ({
          ...obj,
          model: JSON.parse(storedModel),
        }));
      }
      setTableData(updateData);
    }
  }, [data]);

  const handlePricingCall = async () => {
    const rowsToPrice = selectedRows.length > 0
      ? tableData.filter((row) => selectedRows.includes(row.id))
      : tableData;

    if (rowsToPrice.length === 0) {
      return;
    }

    const pricingJsonFormat = {
      inquiringUnitNumber: storedUnitNumber,
      parts: [],
    };

    const partsJsonFormat = rowsToPrice.map((item) => ({
      div: item.divId.substring(2),
      //div: item.divId,
      pls: item.sourceId,
      partNumber: item.number,
      quantity: item.quantity,
    }));

    const updatedPricingJsonFormat = {
      ...pricingJsonFormat,
      parts: [...partsJsonFormat],
    };
    console.log("pricingJsonFormat ...." + JSON.stringify(pricingJsonFormat));
    console.log("partsJsonFormat ...." + JSON.stringify(partsJsonFormat));
    console.log(
      "updatedPricingJsonFormat ...." + JSON.stringify(updatedPricingJsonFormat)
    );
    console.log("model ...." + JSON.stringify(tableData[0]?.model));

    setLoading(true);
    try {
      const updatedResponseText = await fetchWithAuth({
        method: "POST",
        endpoint: `/parts/price/check`,
        data: updatedPricingJsonFormat,
      });

      console.log(
        "updatedResponseText....." + JSON.stringify(updatedResponseText)
      );

      if (updatedResponseText && updatedResponseText.parts) {
        console.log(
          "....updatedResponseText.parts............." +
            JSON.stringify(updatedResponseText.parts)
        );

        const selectedRowIdToIndex = new Map();
        rowsToPrice.forEach((row, index) => {
          selectedRowIdToIndex.set(row.id, index);
        });

        const updatedTableData = tableData.map((row) => {
          const responseIndex = selectedRowIdToIndex.get(row.id);
          if (responseIndex !== undefined) {
            const responseItem = updatedResponseText.parts[responseIndex];
            if (responseItem) {
              const price =
                responseItem.originalPartsSell !== null &&
                responseItem.originalPartsSell !== undefined
                  ? responseItem.originalPartsSell
                  : responseItem.subbedPartsSell !== null &&
                    responseItem.subbedPartsSell !== undefined
                  ? responseItem.subbedPartsSell
                  : "0.00";

              return { ...row, price };
            }
            return { ...row, price: "0.00" };
          }
          return row;
        });

        setTableData(updatedTableData);
        localStorage.setItem("pricingData", JSON.stringify(updatedTableData));

        console.log("......1111111111.......");
        setPricingResultData(updatedResponseText);
        setSelectedTab("PRICING RESULT");
      }
    } catch (error) {
      console.error("Error fetching pricing data", error);
    } finally {
      setLoading(false);
    }
  };

  const handleClearList = () => {
    setTableData([]);
  };

  const handleAddRow = () => {
    const newRow = {
      divId: "",
      sourceId: "",
      number: "",
      quantity: 1,
      model: "X",
      title: "",
      id: Date.now().toString(),
    };
    setTableData([...tableData, newRow]);
  };

  const handleDeleteRow = () => {
    const updatedData = tableData.filter(
      (row) => !selectedRows.includes(row.id)
    );
    setTableData(updatedData);
    setSelectedRows([]);
  };

  const handleCheckboxChange = (event, id) => {
    if (event.target.checked) {
      setSelectedRows([...selectedRows, id]);
    } else {
      setSelectedRows(selectedRows.filter((rowId) => rowId !== id));
    }
  };

  const validate = (row) => {
    const newErrors = {};
    if (!/^\d{4}$/.test(row.divId)) newErrors.divId = "Div should be 4 digits.";
    if (!/^\d{3}$/.test(row.sourceId))
      newErrors.sourceId = "PLS should be 3 digits.";
    if (row.number.length > 24)
      newErrors.number = "Part should be less than 24 characters.";
    if (isNaN(Number(row.quantity)) || row.quantity <= 0)
      newErrors.quantity = "Quantity must be a positive number.";
    return newErrors;
  };

  const handleSave = () => {
    const newErrors = validate(editRow);
    if (Object.keys(newErrors).length) {
      setErrors(newErrors);
      return;
    }
    const updatedData = [...tableData];
    updatedData[editIndex] = editRow;
    setTableData(updatedData);
    setEditIndex(null);
    setEditRow(null);
    setErrors({});
  };

  const handleCancel = () => {
    setEditIndex(null);
    setEditRow(null);
    setErrors({});
  };

  const handleDoubleClick = (index) => {
    console.log("index" + index);
    setEditIndex(index);
    setEditRow({ ...tableData[index] });
    setErrors({});
  };

  const handleChange = (field, value) => {
    setEditRow({ ...editRow, [field]: value });
  };

  return (
    <div className="mainPageContent">
      <table className="toptable" style={{ width: "50%" }}>
        <thead>
          <tr>
            <td>
              <span>
                <h5>Pricing Unit :</h5>
              </span>
            </td>
            <td>
              <input type="text" value={storedUnitNumber} readOnly />
            </td>
            <td>
              <button className="btn btn-info" onClick={handleAddRow}>
                <AddIcon />
              </button>
            </td>
            <td>
              <button
                className="btn btn-info"
                onClick={handleDeleteRow}
                disabled={selectedRows.length === 0}
              >
                <RemoveIcon />
              </button>
            </td>
            <td>
              <button className="btn btn-info" onClick={handlePricingCall}>
                <MonetizationOnIcon /> Price Part
              </button>
            </td>
            <td>
              <button className="btn btn-info" onClick={handleClearList}>
                <DeleteIcon /> Clear List
              </button>
            </td>
          </tr>
        </thead>
      </table>
      <ScrollableComponent height="500px">
        <table className="pricing" style={{ width: "100%" }}>
          <thead>
            <tr>
              <th>
                <input type="checkbox" disabled />
              </th>
              <th>Div</th>
              <th>Pls</th>
              <th>Part</th>
              <th>Quantity</th>
              <th>Price</th>
              <th>Model Number</th>
              <th>Description</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {tableData.map((row, index) => (
              <tr key={row.id || index} onDoubleClick={() => handleDoubleClick(index)}>
                <td>
                  <input
                    type="checkbox"
                    checked={selectedRows.includes(row.id)}
                    onChange={(e) => handleCheckboxChange(e, row.id)}
                  />
                </td>
                {editIndex === index ? (
                  <>
                    <td>
                      <input
                        className={errors.divId ? "input-error" : ""}
                        value={editRow.divId}
                        onChange={(e) => handleChange("divId", e.target.value)}
                      />
                    </td>
                    <td>
                      <input
                        className={errors.sourceId ? "input-error" : ""}
                        value={editRow.sourceId}
                        onChange={(e) =>
                          handleChange("sourceId", e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <input
                        className={errors.number ? "input-error" : ""}
                        value={editRow.number}
                        onChange={(e) => handleChange("number", e.target.value)}
                      />
                    </td>
                    <td>
                      <input
                        className={errors.quantity ? "input-error" : ""}
                        value={editRow.quantity}
                        onChange={(e) =>
                          handleChange("quantity", e.target.value)
                        }
                      />
                    </td>
                    <td>{editRow.price}</td>
                    <td>{editRow.model}</td>
                    <td>{editRow.title}</td>
                    <td>
                      <button onClick={handleSave}>Save</button>
                      <button onClick={handleCancel}>Cancel</button>
                    </td>
                  </>
                ) : (
                  <>
                    <td>{row.divId}</td>
                    <td>{row.sourceId}</td>
                    <td>{row.number}</td>
                    <td>{row.quantity}</td>
                    <td>{row.price}</td>
                    <td>{row.model}</td>
                    <td>{row.title}</td>
                    <td></td>
                  </>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </ScrollableComponent>
      {loading && (
        <>
          <div className="blur-background"></div>
          <div className="loading"></div>
        </>
      )}

      {Object.values(errors).length > 0 && (
        <div className="popup">
          {Object.values(errors).map((err, idx) => (
            <div className="error-text" key={idx}>
              {err}
            </div>
          ))}
          <button className="popup-close" onClick={() => setErrors({})}>
            &times;
          </button>
        </div>
      )}
    </div>
  );
}
